import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { getStates } from '@printdeal/business-logic';
import { SanitizedOrder } from '../../../../../types/order/Order';
import { Environment } from '../../../../../helpers/env';
import { dispatchAccountEvent } from '../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import OrderDetailContext from '../../contexts/OrderDetailContext';
import BillingAddressOnOrder from '../OrderBillingAddress/BillingAddressOnOrderNew';

interface OrderBillingAddressProps {
  order: SanitizedOrder;
}

const OrderBillingAddress = ({
  order,
}: OrderBillingAddressProps) => {
  const { reFetchOrder } = useContext(OrderDetailContext);

  const states = getStates(Environment);

  if (!reFetchOrder) {
    return null;
  }

  const canChangeBillingAddress = () => !order.lineItems.some(
    (lineItem) => lineItem.state[0].state.id === states.lineItem.SHIPPED,
  );

  return (
    <BillingAddressOnOrder
      order={order}
      canChangeBillingAddress={canChangeBillingAddress()}
      onChangeSuccess={async () => {
        await reFetchOrder({
          reFetchPaymentMethods: true,
          reFetchPaymentLink: true,
        });
        dispatchAccountEvent('order_detail_interaction', 'edit_billing_address');
      }}
    >
      {({ billingAddress, changeBillingAddressButton }) => (
        <div className="pd-flex pd-gap-4">
          <div className="pd-w-48">
            <div className="pd-font-bold">
              <FormattedMessage
                id="account.order.addresses.invoice.title"
                defaultMessage="Order invoice"
              />
            </div>
            {changeBillingAddressButton}
          </div>
          <div className="pd-grow">
            {billingAddress}
          </div>
        </div>
      )}
    </BillingAddressOnOrder>
  );
};

export default OrderBillingAddress;
